<template>
  <div :class="$store.state.color + ' hamburger-menu-wrap'">
    <div :class="(open ? 'open ' : '') + 'hamburger-menu'">
      <div class="hamburger-menu__line"></div>
      <div class="hamburger-menu__line"></div>
      <div class="hamburger-menu__line"></div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
export default {
  name: 'hamburger',
  props: {
    open: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="less" scoped>
.hamburger-menu {
  list-style: none; /* summary元素默认会有一个三角形箭头，可以使用这个行代码删除箭头 */
  cursor: pointer;
  width: 18px;
  height: 15px;
  position: relative;
}

.hamburger-menu::-webkit-details-marker {
  display: none;
}
.white .hamburger-menu__line {
  background-color: #fff;
}
.black .hamburger-menu__line {
  background-color: #4d4d4d;
}
.hamburger-menu__line {
  display: block;
  width: 18px;
  height: 1.5px;
  transition: all 0.5s;
  position: absolute;
}
.open .hamburger-menu__line {
  background-color: #4d4d4d;
}

.hamburger-menu__line:first-child {
  top: 0;
}

.hamburger-menu__line:nth-child(2) {
  top: 7px;
}

.hamburger-menu__line:last-child {
  bottom: 0;
}

/* 隐藏中间那条直线 */
.hamburger-menu-wrap .open .hamburger-menu__line:nth-child(2) {
  display: none;
}

/* 将上面那条直线移到中间，并旋转-45deg */
.hamburger-menu-wrap .open .hamburger-menu__line:first-child {
  top: 6px;
  left: -2px;
  width: 22px;
  transform: rotate(-41.3deg);
  transform-origin: center;
}

/* 将下面那条直线也移到中间，并旋转45deg */
.hamburger-menu-wrap .open .hamburger-menu__line:last-child {
  top: 6px;
  left: -2px;
  width: 22px;
  transform: rotate(41.3deg);
  transform-origin: center;
}

@media screen and (max-width: 1023px) {
  .hamburger-menu {
    list-style: none; /* summary元素默认会有一个三角形箭头，可以使用这个行代码删除箭头 */
    cursor: pointer;
    width: 16px;
    height: 14px;
    position: relative;
  }

  .hamburger-menu::-webkit-details-marker {
    display: none;
  }
  .white .hamburger-menu__line {
    background-color: #fff;
  }
  .black .hamburger-menu__line {
    background-color: #4d4d4d;
  }
  .hamburger-menu__line {
    display: block;
    width: 16px;
    height: 1.5px;
    transition: all 0.5s;
    position: absolute;
  }
  .open .hamburger-menu__line {
    background-color: #4d4d4d;
  }

  .hamburger-menu__line:first-child {
    top: 0;
  }

  .hamburger-menu__line:nth-child(2) {
    top: 6px;
  }

  .hamburger-menu__line:last-child {
    bottom: 0;
  }

  /* 隐藏中间那条直线 */
  .hamburger-menu-wrap .open .hamburger-menu__line:nth-child(2) {
    display: none;
  }

  /* 将上面那条直线移到中间，并旋转-45deg */
  .hamburger-menu-wrap .open .hamburger-menu__line:first-child {
    top: 6px;
    left: -1px;
    width: 18px;
    transform: rotate(-41.3deg);
    transform-origin: center;
  }

  /* 将下面那条直线也移到中间，并旋转45deg */
  .hamburger-menu-wrap .open .hamburger-menu__line:last-child {
    top: 6px;
    left: -1px;
    width: 18px;
    transform: rotate(41.3deg);
    transform-origin: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hamburger/index.vue